export default __webpack_public_path__ + "media/aliceVid.766dcfa9.mp4";